import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const handleGetStartedClick = () => {
    // If not on home page, navigate there first
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const downloadSection = document.getElementById('download');
        if (downloadSection) {
          downloadSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Scroll to download section when Get Started is clicked
      const downloadSection = document.getElementById('download');
      if (downloadSection) {
        downloadSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // Close mobile menu if open
    setIsMenuOpen(false);
  };

  const handleNavClick = (sectionId) => {
    // If not on home page, navigate there first
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // Close mobile menu if open
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="nav">
          <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
            <img src="/Logo2.jpg" alt="SyarTech Logo" className="logo-img" />
            <h2>SyarTech</h2>
          </div>
          
          <nav className={`nav-links ${isMenuOpen ? 'nav-open' : ''}`}>
            <button 
              className="nav-link-btn"
              onClick={() => handleNavClick('features')}
            >
              Features
            </button>
            <button 
              className="nav-link-btn"
              onClick={() => handleNavClick('how-it-works')}
            >
              How It Works
            </button>
            <button 
              className="nav-link-btn"
              onClick={() => handleNavClick('download')}
            >
              Download
            </button>
            <button 
              className="btn btn-primary nav-get-started"
              onClick={handleGetStartedClick}
            >
              Get Started
            </button>
          </nav>

          <button 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
